import { BaseThumbnailProps } from '@procore/core-react/dist/_typedoc/Thumbnail/Thumbnail.types.json';
import * as React from 'react';
export default {
  BaseThumbnailProps,
  React
};